import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, MessageSquareOff, CheckCircle } from "lucide-react";
import SEO from "@/components/SEO";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function SmsAbmeldungPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/appointments/sms/revoke`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });
      const data = await res.json();
      if (res.ok) setDone(data.message);
      else toast.error("Bitte eine gültige E-Mail-Adresse angeben.");
    } catch {
      toast.error("Ein Fehler ist aufgetreten");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <SEO title="SMS abbestellen | Personal Fußballtraining" description="SMS-Benachrichtigungen zu Trainingsbuchungen abbestellen." path="/sms-abmeldung" />
      <div className="border-b border-white/10">
        <div className="max-w-xl mx-auto px-4 py-6">
          <Link to="/" className="inline-flex items-center gap-2 text-[#A1A1AA] hover:text-[#c1ff72] transition-colors">
            <ChevronLeft className="w-4 h-4" /> Zurück zur Startseite
          </Link>
        </div>
      </div>
      <div className="max-w-xl mx-auto px-4 py-12">
        <MessageSquareOff className="w-10 h-10 text-[#c1ff72] mb-4" />
        <h1 className="font-['Bebas_Neue'] text-4xl sm:text-5xl mb-3">SMS ABBESTELLEN</h1>
        <p className="text-[#A1A1AA] mb-8">
          Gib die E-Mail-Adresse deiner Buchung an. Danach erhältst du keine SMS-Benachrichtigungen mehr.
          E-Mails zu deiner Buchung und Rechnungen bleiben unverändert.
        </p>
        {done ? (
          <div className="bg-green-500/10 border border-green-500/30 rounded-lg p-4 flex gap-3" data-testid="sms-revoke-success">
            <CheckCircle className="w-5 h-5 text-green-500 shrink-0 mt-0.5" />
            <p className="text-sm">{done}</p>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-[#1A1A1A] rounded-lg p-6 border border-white/10 space-y-4">
            <div>
              <Label htmlFor="revoke-email">E-Mail-Adresse</Label>
              <Input id="revoke-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="max@beispiel.de" className="mt-1 bg-[#0A0A0A] border-white/20" data-testid="input-sms-revoke-email" />
            </div>
            <Button type="submit" disabled={loading || !email} className="w-full bg-[#c1ff72] text-[#0A0A0A] hover:bg-[#a8e65c] font-semibold" data-testid="btn-sms-revoke">
              {loading ? "Wird gesendet..." : "SMS-Benachrichtigungen abbestellen"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
